import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';

import CheckpinModal from '../CheckpinModal';
import ReprintModal from '../ReprintModal';

interface ModalContainerProps {
  children?: React.ReactNode,
  onClose: () => void
}

function ModalContainer({ children, onClose }: ModalContainerProps) {

  return (

    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        { children }
      </div>
    </MaterialModal>

  );
}

ModalContainer.Reprint = ReprintModal;
ModalContainer.Pin = CheckpinModal;

export default ModalContainer;
